<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button size="small" type="primary" @click="add">添加模板</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="provider_id" slot-scope="{row}">
          {{formatProvider(row)}}
        </template>
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="revise(scope.row)">修改</el-button>
              <el-button type="text" class="danger" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <template-operate v-if="templateOperate.visible" :dialog-data="templateOperate" @table-reload="getTableList"/>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import templateOperate from "./dialog/templateOperate"
  import {smsTemplateType, smsTemplateStatus} from "@utils/formatList"
  export default {
    name: "smsTemplate",
    mixins: [PagingData],
    components: {templateOperate},
    data() {
      return {
        // 统计
        countList: [
          {name: "模板总数", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "服务商", property: "provider_id", width: 100},
            {label: "模板类型", property: "type",  width: 100, format: smsTemplateType},
            {label: "模板编号", property: "template_id", width: 120},
            {label: "模板内容", property: "content"},
            {label: "备注", property: "remark"},
            {label: "状态", property: "status", width: 80, format: smsTemplateStatus},
            {label: "创建时间", property: "create_at", width: 140},
          ],
        },
        templateOperate: {visible: false, width: 450, title: "", row: null, providerList: []},
      }
    },
    methods: {
      formatProvider(row) {
        return this.templateOperate.providerList.find(item => +item.id === +row.provider_id)?.name || "未知"
      },
      add() {
        this.templateOperate.visible = true;
        this.templateOperate.title = "添加模板";
        this.templateOperate.row = null;
      },
      revise(row) {
        this.templateOperate.visible = true;
        this.templateOperate.title = "修改模板";
        this.templateOperate.row = row;
      },
      remove(row) {
        this.openConfirm("删除该模板", async ()=> {
          let nv = {optionId: row.id};
          let res = await this.$Http.deleteSmsTemplate(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize,
        };
        let res = await this.$Http.getSmsTemplate(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
      async getProvider() {
        let res = await this.$Http.getProviderOption();
        if (res?.data) {
          this.templateOperate.providerList = res.data.option || [];
        }
      },
    },
    created() {
      this.getTableList();
      this.getProvider();
    }
  }
</script>

<style scoped>

</style>
